import { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

const useSubscriptionCheck = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [needsSubscriptionSelection, setNeedsSubscriptionSelection] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      console.log('🔍 useSubscriptionCheck triggered, user:', user?.email || 'null');
      if (!user) {
        setNeedsSubscriptionSelection(false);
        return;
      }

      // Check if user just completed onboarding
      const urlParams = new URLSearchParams(window.location.search);
      const onboardingComplete = urlParams.get('onboarding_complete');
      console.log('🔍 Onboarding complete param:', onboardingComplete);
      if (onboardingComplete) {
        console.log('✅ Onboarding complete, skipping subscription check');
        setNeedsSubscriptionSelection(false);
        return;
      }

      try {
        setLoading(true);
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        const response = await fetch(`${backendUrl}/api/subscription/current`, {
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          console.log('🔍 Subscription check response:', data);
          setSubscriptionData(data);
          
          // Check if user needs to select a subscription
          if (data.needs_subscription_selection) {
            console.log('🔴 User needs subscription selection, redirecting to pricing');
            setNeedsSubscriptionSelection(true);
            // Redirect to pricing page for subscription selection
            navigate('/pricing');
          } else {
            console.log('✅ User has subscription, no redirect needed');
            setNeedsSubscriptionSelection(false);
          }
        }
      } catch (error) {
        console.error('Error checking subscription:', error);
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, [user, navigate]);

  return { 
    subscriptionData, 
    loading, 
    needsSubscriptionSelection,
    hasSubscription: subscriptionData?.subscription !== null 
  };
};

export default useSubscriptionCheck;